<div class="p-4">
	<h4 class="mb-4">Edit mortgage priorities</h4>

	<div
		*ngFor="let mortgage of mortgages; let i = index"
		class="flex border-b border-grey-veryLight py-4"
	>
		<div class="w-80 flex flex-col justify-center">
			<div>{{ mortgage.name }}</div>
			<div class="flex gap-3">
				<app-pill size="xsmall" mode="secondary">New</app-pill>
				<app-pill size="xsmall" mode="secondary" *ngIf="mortgage.refNumber">{{
					mortgage.refNumber
				}}</app-pill>
			</div>
			<div class="flex">
				<app-pill
					*ngIf="!mortgage?.allowPriorityChange"
					class="mt-2"
					size="xsmall"
					mode="secondary"
					>LLC mortgage</app-pill
				>
			</div>
		</div>

		<div class="w-40 flex justify-center">
			<div *ngIf="!mortgage?.allowPriorityChange">
				{{ mortgage.priorityDescription }}
			</div>
			<div>
				<app-dropdown
					*ngIf="mortgage?.allowPriorityChange"
					[itemGroups]="[{ items: priorityOptions }]"
					[ngModel]="mortgage.priorityDescription"
					(onSelect)="selectPriority($event, i)"
				>
				</app-dropdown>
			</div>
		</div>
	</div>

	<div
		*ngFor="let encumbrance of encumbrances; let i = index"
		class="flex mt-2 border-b border-grey-veryLight py-4"
	>
		<div class="w-80 flex flex-col justify-center">
			<div>{{ encumbrance.name }}</div>
			<div class="flex gap-3">
				<app-pill size="xsmall" mode="secondary">Existing</app-pill>
				<app-pill
					size="xsmall"
					mode="secondary"
					*ngIf="encumbrance.refNumber"
					>{{ encumbrance.refNumber }}</app-pill
				>
			</div>
		</div>
		<div class="w-40">
			<div>
				<app-dropdown
					[itemGroups]="[{ items: priorityOptions }]"
					[ngModel]="encumbrance.priorityDescription"
					(onSelect)="selectEncumbrancePriority($event, i)"
				>
				</app-dropdown>
			</div>
		</div>
	</div>

	<div class="flex justify-between mt-44">
		<app-button btn="secondary" (click)="close()" size="small"
			>Cancel</app-button
		>
		<app-button (click)="save()" size="small">Save</app-button>
	</div>
</div>
